import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  PropertyCompletionReportResponse,
  PropertyCompletionActionRequest,
  PropertyCompletionActionResponse,
} from '../models/property-completion';

@Injectable({
  providedIn: 'root',
})
export class PropertyCompletionService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}/property-completion`;

  uploadAndGenerateReport(file: File) {
    const formData = new FormData();
    formData.append('csvFile', file);

    return firstValueFrom(
      this.http.post<PropertyCompletionReportResponse>(`${this.baseUrl}/report`, formData)
    );
  }

  executeCompletion(request: PropertyCompletionActionRequest) {
    return firstValueFrom(
      this.http.post<PropertyCompletionActionResponse>(`${this.baseUrl}/complete`, request)
    );
  }
}
